import type { Metadata } from "@/lib/head";

import { PublicLayout } from "@/modules/landing/ui/public-header";
import { TERMS_DOC } from "@/modules/legal/content";
import LegalDocView from "@/modules/legal/legal-doc";
import { useSignedIn } from "@/pages/landing-session";

export const metadata: Metadata = {
  title: "이용약관",
  description: "buildpy(빌드파이) 서비스 이용약관(초안).",
};

export const TermsView = ({ signedIn }: { signedIn: boolean }) => (
  <PublicLayout signedIn={signedIn}>
    <LegalDocView doc={TERMS_DOC} testId="terms-page" />
  </PublicLayout>
);

const TermsPage = () => <TermsView signedIn={useSignedIn()} />;

export default TermsPage;
